// https://www.npmjs.com/package/vue-infinite-scroll

import Vue from "vue"
import infiniteScroll from "vue-infinite-scroll"

Vue.use(infiniteScroll)
